import { createSurveyStyles } from '@sm/webassets';

const useStyles = createSurveyStyles(surveyTheme => ({
  text: {
    color: surveyTheme.questionColor,
    fontSize: '12px',
    fontWeight: 400,
    lineHeight: '18px',
    fontFamily: 'National2,"Helvetica Neue",Helvetica,Arial,sans-serif',
    display: 'inline-block',
  },
  reportContainer: {
    color: surveyTheme.questionColor,
    display: 'inline-block',
    lineHeight: '18px',
    fontSize: '12px',
    fontFamily: 'National2,"Helvetica Neue",Helvetica,Arial,sans-serif',
  },
}));

export default useStyles;
